import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { VarianceService } from 'src/app/services/variance.service';
import { AuthService } from 'src/app/services/auth.service';
import { LocationAccessService } from 'src/app/services/location-access.service';
import { TreeNode } from "primeng/api";
import { ResolutionCodingService } from "src/app/services/resolution-coding.service";
import { ILogger, LOGGER_TOKEN } from 'src/app/services/logger/ilogger';

@Component({
    selector: 'app-link-transaction',
    templateUrl: './link-transaction.component.html',
    styleUrls: ['./link-transaction.component.css'],
    standalone: false
})
export class LinkTransactionComponent {
  private readonly logger = inject<ILogger>(LOGGER_TOKEN);
  private varService = inject(VarianceService);
  authService = inject(AuthService);
  private resolutionCodingService = inject(ResolutionCodingService);
  private locationAccessService = inject(LocationAccessService);

  @Input() items!:string;
  varianceNodes: TreeNode[] = [];
  cols:any[];
  filter: any = {
    duration: 2,
    ...this.locationAccessService.buildAuthorizedFilters(
      this.locationAccessService.buildInitialFilters(this.authService.user),
      this.authService.user
    ),
    serviceGroup: "All",
    deIdentifyData: true,
    allAdcEhr: false,
    _id: [],
    showMultiAdmins: "false",
  };
  totalCount = 0;
  records: any[] = [];

  selectedCount = 0;
  selectedIds: any[] = [];
  masterSelected = false;
  tableDataIsLoading = false;
  @Output() selectedData = new EventEmitter<any>();

  constructor() {
    // this.cols = [
    //   { field: 'PatientName', header: 'PATIENT NAME' },
    //   { field: 'PatientID', header: 'PATIENT ID' },
    //   { field: 'MedDescription', header: 'MED DESC' },
    //   { field: 'Device', header: 'LOC' },
    //   { field: 'Discrepancy', header: 'QTY' },
    //   { field: 'UOM', header: 'UOM' },
    //   { field: 'varDateString', header: 'TIME OF ADMINISTRATION' },
    //   { field: 'UserName', header: 'ADMIN NAME' },
    //   { field: 'UserID', header: 'ADMIN ID' },
    //   { field: 'adminGroup', header: 'ADMIN TYPE' },
    //   { field: 'TransactionType', header: 'TRANSACTION TYPE' },
    // ];
    this.cols = [
      { field: 'patientName', header: 'Patient Name' },
      { field: 'mrnNum', header: 'Patient ID' },
      { field: 'medDesc', header: 'Med Description' },
      { field: 'bedDev', header: 'Stock Area' },
      { field: 'amount', header: 'QTY' },
      { field: 'uom', header: 'UOM' },
      { field: 'varDateString', header: 'Time of Administration' },
      { field: 'employeeName', header: 'User Name' },
      { field: 'lanID', header: 'User ID' },
      { field: 'userGroup', header: 'Role' },
      { field: 'transType', header: 'Transaction Type' },
     // { field: 'RecordType', header: 'Data Source' },   //this field is not in discrpancy2
    ];
   }

  loadRecordsLazy(event: any) {
    this.tableDataIsLoading = true;
    this.filter.allAdcEhr = true;
    this.filter.uniqueKey2 = this.items;
    this.varService.getLinkTransactionOption(event["first"], 10, this.filter)
    .subscribe(
      (res: any) => {
        this.tableDataIsLoading = false;
        // this.totalCount = res["count"];
        // if(this.items['varDateString']) {
        // this.formatDateCustom(this.items['varDateString'])
        // }
        this.records = res;
      }, (err) => {
        this.logger.exception(err)
      }
    );
  }

  formatDateCustom(dateStr: string): string {
    let output = '';
    const dateObj = new Date(dateStr); // creating new object from date string
    const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, '0');
    // takes jan as 0, so we have to update it by 1 
    output += month + '/';
    const date = (dateObj.getUTCDate()).toString().padStart(2, '0');
    output += date + '/';
    const fullYear = dateObj.getUTCFullYear();
    output += fullYear + ' | ';
    const hours = (dateObj.getUTCHours()).toString().padStart(2, '0');
    output += hours + ':';
    const minutes = (dateObj.getUTCMinutes()).toString().padStart(2, '0');
    output += minutes;
    return output;
  }

  filterRecords() {
    const obj = {};
    (obj as any)["first"] = 0;
    this.loadRecordsLazy(obj);
  }

  getResolutionBg(val: any) {
    return this.resolutionCodingService.getReolutionCodingBg(val);
  }

  checkUncheckAll(e: any){
    if (e.target.checked) {
      this.masterSelected = true;
      for (const varianceNode of this.varianceNodes) {
        this.filter._id.push(varianceNode["data"]["id"]);
        varianceNode["data"].isSelected = true;
      }
    } else {
      this.masterSelected = false;
      for (const varianceNode of this.varianceNodes) {
        const index: number = this.filter._id.indexOf(
          varianceNode["data"]["id"]
        );
        this.filter._id.splice(index, 1);
        varianceNode["data"].isSelected = false;
      }
    }
  }

  toLink(e: any, rowData: any) {
    if (e.target.checked) {
      if (this.selectedCount < 20) {
        this.selectedIds.push(rowData.id);
        this.selectedCount++;
      } else {
        return;
      }
      if (this.selectedCount == 20) {
        alert('Only 20 entires can be selected');
      }
    } else if (this.selectedCount > 0) {
      const index: number = this.selectedIds.indexOf(rowData.id);
      if (index !== -1) {
        this.selectedIds.splice(index, 1);
        this.selectedCount--;
      }
    } 
    // rowData['patientName'] = rowData['PatientName']
    // rowData['patientId'] = rowData['PatientID']
    // rowData['uom'] = rowData['UOM']
    // rowData['transType'] = rowData['TransactionType']
    // rowData['medDesc'] = rowData['MedDescription']
    // rowData['loc'] = rowData['Device']
    // rowData['adminId'] = rowData['UserID']
    // rowData['entityType'] = rowData['UserType']
    // rowData['recordType'] = rowData['RecordType']
    // rowData['amount'] = rowData['Discrepancy']
    this.selectedData.emit(rowData);
  }

  getChildRowClass(rowtype: any){
    if(rowtype == 'ADC')
    {
      return "detailsrow-adc-data";
    }
    else if(rowtype == 'EHR')
    {
      return "detailsrow-ehr-data";
    }
  }

}
